import { AppPagePaths } from "App/routes/paths";
import { AgentDesktopSubPages } from "Services/state/agent/desktopUI/AgentDesktopUISlice";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import AgentDesktopRouter from "./AgentDesktopRoutingPage";
import { agentDesktopSettingsRoute } from "./Pages/AgentDesktopSettings/Pages/AgentDesktopSettingsRoutes";
import { AgentDesktopPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const Desktop = lazyWithRetries(
    "Desktop page",
    () => import(/* webpackChunkName: "desktop" */ "./Pages/AgentDesktopTasks/AgentDesktopTasks")
);

export const agentDesktopRoute: RegalRouteObject = {
    path: AppPagePaths.agentDesktop,
    element: <AgentDesktopRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Desktop />,
        },
        ...AgentDesktopPaths.contacts.map((path) => ({
            path,
            element: <Desktop selectedPage={AgentDesktopSubPages.CONTACT_PAGE} />,
        })),
        agentDesktopSettingsRoute,
    ],
};
